import * as React from 'react';

function SvgEdit(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.92 12.323H1.08a.58.58 0 000 1.16h11.84a.58.58 0 000-1.16zM4 10.585a.655.655 0 00.24-.05h.006l3.298-1.549.034-.017 5.61-5.613a1.009 1.009 0 000-1.433L12.054.793a1.014 1.014 0 00-1.434.001L5.033 6.377l-.025.026-.015.032-1.543 3.28a.599.599 0 00.037.587.62.62 0 00.514.283zm6.663-8.198l.673-.673.927.928-.672.672-.928-.927zM5.146 8.829l.823-1.75 3.875-3.873.927.928-3.874 3.872-1.75.823z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgEdit;
